import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { StateContext } from '../../../StateProvider/index.js';

function Tasks() {
  var ctx = useContext(StateContext) || {};
  var user = ctx.user;
  var navigate = useNavigate();

  var _useState1 = useState(true), boot = _useState1[0], setBoot = _useState1[1];
  var _useState2 = useState(''), job = _useState2[0], setJob = _useState2[1];

  // Derive job safely on mount / user change
  useEffect(function () {
    var r = '';
    if (user && user.info && user.info.job) {
      r = String(user.info.job).toLowerCase().trim();
    }
    setJob(r);
    setBoot(false);
  }, [user]);

  // Redirect once job is known
  useEffect(function () {
    if (boot) return;

    var r = job ? String(job).toLowerCase().trim() : '';
    var key = r.replace(/[\s\-_]+/g, ''); // e.g., "front desk" -> "frontdesk"

    var target = '';
    if (key === 'admin') target = '/console/tasks/admin';
    else if (key === 'manager') target = '/console/tasks/manager';
    else if (key === 'groomer') target = '/console/tasks/groomer';
    else if (key === 'reception') target = '/console/tasks/reception';
    else if (key === 'trainer') target = '/console/tasks/trainer';
    else if (key === 'daycare') target = '/console/tasks/daycare';
    // else if (key === 'boarding') target = '/console/tasks/boarding';
    // else if (key === 'adventure') target = '/console/tasks/adventure';
    else if (key === 'shuttle') target = '/console/tasks/shuttle';
    // else if (key === 'inventory') target = '/console/tasks/retail';

    if (target) {
      navigate(target, { replace: true });
    }
  }, [boot, job, navigate]);

  if (boot) {
    return <div style={{ padding: '2rem' }}>Loading tasks…</div>;
  }

  // Unknown job fallback
  return (
    <div style={{ padding: '2rem', fontSize: '1.2rem' }}>
      🐾 Your job doesn’t have a task board yet. Check back soon or contact your manager.
    </div>
  );
}

export default Tasks;
